__webpack_require__.p = "/reports-details-manage-locations/account-setup/";